export default __webpack_public_path__ + "static/media/icon_arrow_top_right.fc81d10a.svg";